export const CUSTOM_ENDPOINTS = [
  process.env.PF_SEARCH_GQL_RELATIVE_PATH,
  '/assets_prefix',
  '/callai/apollo-server/graphapi',
];
